export default {
  path: '/my-fol-old',
  meta: {
    title: '地面实体店',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my-fol-old`),
}



// WEBPACK FOOTER //
// ./src/views/Myfollow-old/router.js